import BatchActionsSelect from './BatchActionsSelect'

export default BatchActionsSelect
